import React, { FC, ReactNode } from 'react';
import Typo from '../Typography/Typo';

type TTerritoryTabTitleProps = {
  children: ReactNode;
};

export const TerritoryTabTitle: FC<TTerritoryTabTitleProps> = ({ children }) => (
  <>
    <Typo
      tag="h1"
      variant="h1"
      className="!text-[28px] !leading-none !font-secondary font-semibold text-t2-neutral-grey06"
    >
      t/{children}
    </Typo>
    <Typo variant="p1" className="mx-3 text-t2-neutral-grey05">
      /
    </Typo>
  </>
);
